import cupOption1 from "/public/Images/cupOption1.gif";
import cupOption2 from "/public/Images/cupOption2.gif";
import cupOption3 from "/public/Images/cupOption3.gif";
import cupOption4 from "/public/Images/cupOption4.gif";
import mouldedBra from "/public/Images/mouldedBra.jpg";
import fabricBra from "/public/Images/fabricBra.jpg";

// bf2
export const bf2 = [
  {
    id: 1,
    type: "prompt",
    content:
      "We can certainly help. To ensure the best fit, let's double-check the band and cup sizes. We can do this by having you try on the bra and examining how it fits.",
    options: [{ label: "Cup Fit Quiz", next: 2 }],
    next: 2,
  }, // braSizeInput
  {
    id: 2,
    type: "braSizeInput",
    content: "Enter your current bra size:",
    options: [{ label: "Bra Fit Quiz", next: 2 }],
    next: 3,
  },
  {
    id: 3,
    type: "promptWithImages",
    content: "Thanks for that! Next question: Is this a moulded or fabric bra?",
    options: [
      {
        label: "A moulded T-shirt bra",
        image: mouldedBra,
        next: 4,
      },
      {
        label: "A fabric bra",
        image: fabricBra,
        next: 11,
      },
    ],
  },
  {
    id: 4,
    type: "promptWithImages",
    content:
      "Great! Now put the bra on yourself, on the tightest hook. Then tighten up your bra band by pinching it as the back until it's snug, how would you rate the gaping now?",
    options: [
      {
        label: "Significant gaping still",
        image: cupOption1,
        next: 5,
      },
      {
        label: "Slight top gaping",
        image: cupOption2,
        next: 6,
      },
      {
        label: "No gaping",
        image: cupOption3,
        next: 7,
      },
      {
        label: "Snug band",
        image: cupOption4,
        next: 8,
      },
    ],
    next: 8,
  },
  {
    id: 5,
    type: "result",
    content:
      "Thanks for that. I suggest we try going down in both 1 band size and 1 cup size.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 6,
    type: "result",
    content:
      "Thanks for that. Sounds like the gaping has reduced. I suggest going down 1 band size, whilst keeping the cup volume the same. It’s completely normal to have a bit of gaping for moulded cups if your breasts tissues are more hollow or empty at the top.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 7,
    type: "result",
    content:
      "Sounds like the gaping has reduced. I suggest going down 1 band size, whilst keeping the cup volume the same.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 8,
    type: "result",
    content:
      "Thanks for that. I suggest we try going down 1 cup size, keeping the band size the same",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 11,
    type: "promptWithImages",
    content:
      "Great! Now put the bra on yourself, on the tightest hook. Then tighten up your bra band by pinching it as the back until it's snug, how would you rate the gaping now?",
    options: [
      {
        label: "Gaping is still there significantly",
        image: cupOption1,
        next: 12,
      },
      {
        label: "Gaping is still there a bit just on top",
        image: cupOption2,
        next: 13,
      },
      {
        label: "Gaping is gone",
        image: cupOption3,
        next: 14,
      },
      {
        label: "My band is already snug, I cannot pinch any extra fabric",
        image: cupOption4,
        next: 15,
      },
    ],
    next: 15,
  },
  {
    id: 12,
    type: "result",
    content:
      "Thanks for that. I suggest we try going down both the band size and the cup size.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 13,
    type: "result",
    content:
      "Thanks for that. Sounds like the gaping has reduced. I suggest going down a band size, whilst keeping the cup volume the same. We might also want to explore a different bra style to accomodate your shapes better such as plunges.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 14,
    type: "result",
    content: "Sounds like the gaping has reduced. I suggest going down a band size, whilst keeping the cup volume the same.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 15,
    type: "result",
    content:
      "Thanks for that. I suggest we try going down a cup size, keeping the band size them same.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
];
